import React, { Component } from 'react';
import { number, func, object, string, array } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import InPlaceIndicator from 'ps-components/LoadingIndicator/InPlaceIndicator/InPlaceIndicator';
import JobPricingSummarySliderHeader from './JobPricingSummarySliderHeader/JobPricingSummarySliderHeader';
import JobPricingSummaryHeader from './JobPricingSummaryHeader/JobPricingSummaryHeader';
import JobPricingSummaryList from './JobPricingSummaryList/JobPricingSummaryList';
import JobPricingSummaryTabResults from './JobPricingSummaryTabResults/JobPricingSummaryTabResults';

import { viewPricedJobs, viewNotPricedJobs } from '../RulesActions';
import { setSelectedBenchmarkYear } from '../../CompensationSummary/CompensationSummaryActions';
import { showModal } from '../../../actions/modal';
import { addJob, clearSelectedJobs } from '../../JobMatching/OrgJobsActions';
import './JobPricingSummaryContainer.scss';
import { SLIDEOUTS } from '../../Slideout/Slideouts';

class JobPricingSummaryContainer extends Component {
  static propTypes = {
    showSlideout: func,
    summaryData: object,
    viewNotPricedJobs: func,
    viewPricedJobs: func,
    ruleName: string,
    actions: object,
    hideSlideout: func,
    selectedJobs: array,
    benchmarkYear: number,
    setSelectedBenchmarkYear: func
  };

  returnToJobs = () => {
    const { showSlideout } = this.props;
    showSlideout(SLIDEOUTS.JOB_MATCHING_SLIDEOUT);
  };

  render() {
    const {
      actions,
      hideSlideout,
      selectedJobs,
      launchDarklyFeatureFlags,
      summaryData,
      ruleName,
      history,
      benchmarkYear
    } = this.props;

    const numSelectedJobs = summaryData ? summaryData.priced.length + summaryData.skipped.length : 0;
    let jobsSummaryList = [];
    let notes = '';

    if (summaryData === null) {
      return (
        <div className="pricing-summary">
          <InPlaceIndicator />
        </div>
      );
    }

    if (summaryData) {
      if (summaryData.selectedTab === 'notPriced') {
        jobsSummaryList = summaryData.skipped;
        notes =
          jobsSummaryList.length === 0 ? 'No jobs that cannot be priced.' : 'Select jobs to generate comp summary.';
      } else {
        jobsSummaryList = summaryData.priced;
        notes = jobsSummaryList.length === 0 ? 'No jobs were priced.' : 'Select jobs to generate comp summary';
      }
    }

    return (
      <div className="pricing-summary">
        <JobPricingSummarySliderHeader closeSlideout={this.returnToJobs} ruleName={ruleName} />
        <div className="results">
          <JobPricingSummaryHeader onClick={this.returnToJobs} selectedJobs={numSelectedJobs} />
          <JobPricingSummaryTabResults
            summaryData={summaryData}
            viewNotPricedJobs={actions.viewNotPricedJobs}
            viewPricedJobs={actions.viewPricedJobs}
          />
          <JobPricingSummaryList
            data={jobsSummaryList}
            notes={notes}
            selectedTab={summaryData.selectedTab}
            addCompSummaryID={actions.addJob}
            selectedJobs={selectedJobs}
            showModal={actions.showModal}
            clearSelectedJobs={actions.clearSelectedJobs}
            history={history}
            setSelectedBenchmarkYear={actions.setSelectedBenchmarkYear}
            benchmarkYear={benchmarkYear}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ rules, orgJobs, session }) => ({
  summaryData: rules.summaryData,
  ruleName: rules.ruleName,
  selectedJobs: orgJobs.jobs,
  benchmarkYear: session.benchmarkYear
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      viewNotPricedJobs,
      viewPricedJobs,
      addJob,
      showModal,
      clearSelectedJobs,
      setSelectedBenchmarkYear
    },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(JobPricingSummaryContainer);
